var map = {
	"./locales/ar copy.json": 1942,
	"./locales/ar.json": 6726,
	"./locales/ar_last_copy.json": 3989,
	"./locales/en copy.json": 6752,
	"./locales/en.json": 790,
	"./locales/en_last_copy.json": 6451,
	"./locales/sidebar.json": 3679
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9594;